var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIrradiation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    preserveAspectRatio: "xMidYMid meet",
    viewBox: "-160 -160 800 800",
    width: 960,
    height: 960,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M320.29 138.91L327.12 139.6L333.87 140.57L340.54 141.8L347.11 143.28L353.58 145.02L359.95 147.01L366.21 149.23L372.36 151.69L378.38 154.39L384.28 157.3L390.05 160.44L395.68 163.79L401.17 167.35L406.51 171.11L411.69 175.07L416.72 179.22L421.59 183.56L426.28 188.08L430.8 192.77L435.14 197.64L439.29 202.67L443.25 207.85L447.01 213.19L450.57 218.68L453.92 224.31L457.06 230.08L459.97 235.98L462.67 242L465.13 248.15L467.36 254.41L469.34 260.78L471.08 267.25L472.56 273.82L473.79 280.49L474.76 287.24L475.45 294.07L475.88 300.98L476.02 307.96L475.88 314.94L475.45 321.85L474.76 328.69L473.79 335.44L472.56 342.1L471.08 348.68L469.34 355.15L467.36 361.52L465.13 367.78L462.67 373.92L459.97 379.95L457.06 385.85L453.92 391.61L450.57 397.24L447.01 402.73L443.25 408.07L439.29 413.26L435.14 418.29L430.8 423.15L426.28 427.85L421.59 432.36L416.72 436.7L411.69 440.85L406.51 444.81L401.17 448.57L395.68 452.13L390.05 455.48L384.28 458.62L378.38 461.54L372.36 464.23L366.21 466.69L359.95 468.92L353.58 470.91L347.11 472.64L340.54 474.13L333.87 475.36L327.12 476.32L320.29 477.02L313.38 477.44L306.4 477.58L299.42 477.44L292.51 477.02L285.67 476.32L278.92 475.36L272.26 474.13L265.69 472.64L259.21 470.91L252.84 468.92L246.58 466.69L240.44 464.23L234.41 461.54L228.51 458.62L222.75 455.48L217.12 452.13L211.63 448.57L206.29 444.81L201.1 440.85L196.07 436.7L191.21 432.36L186.51 427.85L182 423.15L177.66 418.29L173.51 413.26L169.55 408.07L165.79 402.73L162.23 397.24L158.88 391.61L155.74 385.85L152.82 379.95L150.13 373.92L147.67 367.78L145.44 361.52L143.45 355.15L141.72 348.68L140.23 342.1L139 335.44L138.04 328.69L137.34 321.85L136.92 314.94L136.78 307.96L136.92 300.98L137.34 294.07L138.04 287.24L139 280.49L140.23 273.82L141.72 267.25L143.45 260.78L145.44 254.41L147.67 248.15L150.13 242L152.82 235.98L155.74 230.08L158.88 224.31L162.23 218.68L165.79 213.19L169.55 207.85L173.51 202.67L177.66 197.64L182 192.77L186.51 188.08L191.21 183.56L196.07 179.22L201.1 175.07L206.29 171.11L211.63 167.35L217.12 163.79L222.75 160.44L228.51 157.3L234.41 154.39L240.44 151.69L246.58 149.23L252.84 147.01L259.21 145.02L265.69 143.28L272.26 141.8L278.92 140.57L285.67 139.6L292.51 138.91L299.42 138.49L306.4 138.34L313.38 138.49L320.29 138.91ZM297.3 197.23L292.82 197.68L288.4 198.32L284.04 199.12L279.73 200.09L275.49 201.23L271.32 202.53L267.22 203.99L263.19 205.6L259.25 207.37L255.38 209.28L251.6 211.33L247.92 213.53L244.32 215.86L240.82 218.32L237.43 220.92L234.13 223.64L230.95 226.48L227.87 229.44L224.91 232.51L222.07 235.7L219.35 238.99L216.76 242.39L214.29 245.89L211.96 249.48L209.77 253.17L207.71 256.95L205.8 260.81L204.04 264.76L202.43 268.78L200.97 272.88L199.67 277.05L198.53 281.29L197.56 285.6L196.75 289.96L196.12 294.39L195.66 298.86L195.39 303.39L195.29 307.96L195.39 312.53L195.66 317.06L196.12 321.54L196.75 325.96L197.56 330.33L198.53 334.63L199.67 338.87L200.97 343.04L202.43 347.14L204.04 351.17L205.8 355.11L207.71 358.98L209.77 362.76L211.96 366.44L214.29 370.04L216.76 373.54L219.35 376.93L222.07 380.23L224.91 383.41L227.87 386.49L230.95 389.45L234.13 392.29L237.43 395.01L240.82 397.6L244.32 400.07L247.92 402.4L251.6 404.59L255.38 406.65L259.25 408.56L263.19 410.32L267.22 411.93L271.32 413.39L275.49 414.69L279.73 415.83L284.04 416.81L288.4 417.61L292.82 418.24L297.3 418.7L301.83 418.97L306.4 419.07L310.97 418.97L315.5 418.7L319.97 418.24L324.4 417.61L328.76 416.81L333.07 415.83L337.31 414.69L341.48 413.39L345.58 411.93L349.6 410.32L353.55 408.56L357.41 406.65L361.19 404.59L364.88 402.4L368.47 400.07L371.97 397.6L375.37 395.01L378.66 392.29L381.85 389.45L384.92 386.49L387.88 383.41L390.72 380.23L393.44 376.93L396.04 373.54L398.5 370.04L400.83 366.44L403.03 362.75L405.08 358.98L406.99 355.11L408.76 351.17L410.37 347.14L411.83 343.04L413.13 338.87L414.27 334.63L415.24 330.32L416.04 325.96L416.68 321.54L417.13 317.06L417.41 312.53L417.5 307.96L417.41 303.39L417.13 298.86L416.68 294.39L416.04 289.96L415.24 285.6L414.27 281.29L413.13 277.05L411.83 272.88L410.37 268.78L408.76 264.76L406.99 260.81L405.08 256.95L403.03 253.17L400.83 249.48L398.5 245.89L396.04 242.39L393.44 238.99L390.72 235.7L387.88 232.51L384.92 229.44L381.85 226.48L378.66 223.64L375.37 220.92L371.97 218.32L368.47 215.86L364.88 213.53L361.19 211.33L357.41 209.28L353.55 207.37L349.6 205.6L345.58 203.99L341.48 202.53L337.31 201.23L333.07 200.09L328.76 199.12L324.4 198.32L319.97 197.68L315.5 197.23L310.97 196.95L306.4 196.86L301.83 196.95L297.3 197.23Z",
    id: "cJTmseTK7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.56 70.07C340.56 66.14 340.56 34.75 340.56 30.83C340.56 14.67 327.46 1.57 311.3 1.57C295.14 1.57 282.04 14.67 282.04 30.83C282.04 34.75 282.04 66.14 282.04 70.07C282.04 86.23 295.14 99.33 311.3 99.33C327.46 99.33 340.56 86.23 340.56 70.07Z",
    id: "a1U2WbU6k"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.63 167.99C148.12 167.99 155.61 165.13 161.32 159.42C172.75 147.99 172.75 129.47 161.32 118.04C158.55 115.27 136.35 93.07 133.57 90.3C122.15 78.87 103.62 78.87 92.2 90.3C80.77 101.72 80.77 120.25 92.2 131.67C94.05 133.52 103.29 142.77 119.94 159.42C128.74 165.13 135.64 167.99 140.63 167.99Z",
    id: "b12gGiMknu"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.5 278.71C64.58 278.71 33.18 278.71 29.26 278.71C13.1 278.71 0 291.8 0 307.96C0 324.12 13.1 337.22 29.26 337.22C33.18 337.22 64.58 337.22 68.5 337.22C84.66 337.22 97.76 324.12 97.76 307.96C97.76 291.8 84.66 278.71 68.5 278.71Z",
    id: "b7FBnUEsX"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.17 530.24C32.75 541.67 32.75 560.19 44.17 571.62C49.89 577.34 57.38 580.19 64.86 580.19C72.35 580.19 79.84 577.34 85.55 571.62C85.98 571.19 89.45 567.72 89.89 567.29C101.31 555.86 101.31 537.34 89.89 525.91C78.46 514.48 59.94 514.48 48.51 525.91C47.64 526.77 44.61 529.81 44.17 530.24Z",
    id: "a47YD7gYN1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.42 471C91.99 482.43 91.99 500.95 103.42 512.38C109.13 518.1 116.62 520.95 124.11 520.95C131.59 520.95 139.08 518.1 144.8 512.38C146.1 511.08 156.55 500.63 157.85 499.33C169.28 487.9 169.28 469.37 157.85 457.95C146.43 446.52 127.9 446.52 116.47 457.95C113.86 460.56 104.72 469.7 103.42 471Z",
    id: "a5fg3WQhN"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.14 590.01C277.14 606.17 290.24 619.27 306.4 619.27C322.56 619.27 335.66 606.17 335.66 590.01C335.66 586.08 335.66 554.69 335.66 550.77C335.66 534.61 322.56 521.51 306.4 521.51C290.24 521.51 277.14 534.61 277.14 550.77C277.14 558.62 277.14 586.08 277.14 590.01Z",
    id: "a19MaNw5do"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M456.38 461.41C444.95 472.84 444.95 491.37 456.38 502.79C459.15 505.57 481.35 527.76 484.12 530.54C489.84 536.25 497.32 539.11 504.81 539.11C512.3 539.11 519.79 536.25 525.5 530.54C536.93 519.11 536.93 500.59 525.5 489.16C523.65 487.31 514.4 478.06 497.76 461.41C477.79 453.8 464 453.8 456.38 461.41Z",
    id: "bg98JOJA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M549.2 342.13C553.12 342.13 584.52 342.13 588.44 342.13C604.6 342.13 617.7 329.03 617.7 312.87C617.7 296.71 604.6 283.61 588.44 283.61C584.52 283.61 553.12 283.61 549.2 283.61C533.04 283.61 519.94 296.71 519.94 312.87C519.94 329.03 533.04 342.13 549.2 342.13Z",
    id: "cgmEkR49d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M569.58 94.53C570.13 93.98 574.51 89.6 575.06 89.05C586.49 77.63 586.49 59.1 575.06 47.67C563.63 36.25 545.11 36.25 533.68 47.67C533.13 48.22 528.75 52.6 528.2 53.15C516.78 64.57 516.78 83.1 528.2 94.53C533.92 100.24 541.41 103.1 548.89 103.1C556.38 103.1 563.87 100.24 569.58 94.53Z",
    id: "a1QcjGsX8C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M501.22 162.89C502.53 161.58 512.97 151.14 514.28 149.83C525.7 138.4 525.7 119.88 514.28 108.45C502.85 97.03 484.32 97.03 472.9 108.45C471.59 109.76 461.15 120.2 459.85 121.51C448.42 132.94 448.42 151.46 459.85 162.89C465.56 168.6 473.05 171.46 480.54 171.46C488.02 171.46 495.51 168.6 501.22 162.89Z",
    id: "b1iMjAxIp5"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#cJTmseTK7",
    opacity: 1,
    fill: "#000000",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#cJTmseTK7",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a1U2WbU6k",
    opacity: 1,
    fill: "#000000",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a1U2WbU6k",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b12gGiMknu",
    opacity: 1,
    fill: "#000000",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b12gGiMknu",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b7FBnUEsX",
    opacity: 1,
    fill: "#000000",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b7FBnUEsX",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a47YD7gYN1",
    opacity: 1,
    fill: "#000000",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a47YD7gYN1",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a5fg3WQhN",
    opacity: 1,
    fill: "#000000",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a5fg3WQhN",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a19MaNw5do",
    opacity: 1,
    fill: "#000000",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a19MaNw5do",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#bg98JOJA",
    opacity: 1,
    fill: "#000000",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#bg98JOJA",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#cgmEkR49d",
    opacity: 1,
    fill: "#000000",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#cgmEkR49d",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a1QcjGsX8C",
    opacity: 1,
    fill: "#000000",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a1QcjGsX8C",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b1iMjAxIp5",
    opacity: 1,
    fill: "#000000",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b1iMjAxIp5",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIrradiation);
export default __webpack_public_path__ + "static/media/irradiation.52475bad7e3a862c19e552cf003e2323.svg";
export { ForwardRef as ReactComponent };